<section class="py-3">
  <div class="container-fluid card inner-scroll">
    <h3 class="text strat pt-3">Product Sale Information</h3>
    <form (ngSubmit)="saveProduct()" [formGroup]="addProductForm">
      <div class="row pt-3 g-3">
        @if (userDetails?.enrollmentType === "Company") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="branchSelect">Branch<span class="text-danger">*</span></label>
          <ng-select labelForId="branchSelect" [items]="filteredActiveBranches" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="false" [searchable]="true" placeholder="Select Branch" formControlName="company"
            class="ng-select-bootstrap" appendTo="body" [readonly]="isEditMode" (change)="onBranchChange()">
          </ng-select>
          @if (
          addProductForm.controls["company"].invalid &&
          (addProductForm.get("company")?.dirty ||
          addProductForm.controls["company"].touched)
          ) {
          <div class="errorText">
            @if (addProductForm.controls["company"].errors?.["required"]) {
            <div>
              <small class="text-danger">Select Branch Type</small>
            </div>
            }
          </div>
          }
        </div>
        }
        @for (item of stock.controls; track item; let i = $index) {
        <div formArrayName="stock" class="stockArray">
          <div class="row g-3 border-bottom pb-4 mb-2" [formGroupName]="i">
            <div class="col-12 col-sm-6 col-md-3">
              <label [attr.for]="'tyreSizeSelect_' + i">Tyre Size<span class="text-danger">*</span></label>
              <ng-select [labelForId]="'tyreSizeSelect_' + i" [items]="tyreSizeObj.list" bindLabel="tyreSize" bindValue="tyreSize" [multiple]="false"
                [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Size"
                formControlName="tyreSize" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
                [readonly]="isEditMode" (scrollToEnd)="onScrollTyreSize()" (search)="onTyreSizeInputChange($event)"
                (close)="onSizeClose()" (clear)="onSizeClose()">
              </ng-select>
              @if (
              $any(stock).controls[i].controls["tyreSize"].invalid &&
              ($any(stock).controls[i].controls["tyreSize"]?.dirty ||
              $any(stock).controls[i].controls["tyreSize"].touched)
              ) {
              <div class="errorText">
                @if (
                $any(stock).controls[i].controls["tyreSize"].errors?.[
                "required"
                ]
                ) {
                <div>
                  <small class="text-danger">Select Tyre Size</small>
                </div>
                }
              </div>
              }
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label [attr.for]="'tyreMakeSelect_' + i">Tyre Make<span class="text-danger">*</span></label>
              <ng-select [labelForId]="'tyreMakeSelect_' + i" [items]="tyreMakeObj.list" [multiple]="false" [clearable]="true" [searchable]="true"
                placeholder="Search or Select Tyre Make" formControlName="tyreMake" class="ng-select-bootstrap"
                appendTo="body" [searchFn]="customSearchFn" [readonly]="isEditMode" (change)="selectMake($event, i)"
                (search)="onTyreMakeInputChange($event)" (close)="onMakeClose()" (clear)="onMakeClose()">
              </ng-select>
              @if (
              $any(stock).controls[i].controls["tyreMake"].invalid &&
              ($any(stock).controls[i].controls["tyreMake"]?.dirty ||
              $any(stock).controls[i].controls["tyreMake"].touched)
              ) {
              <div class="errorText">
                @if (
                $any(stock).controls[i].controls["tyreMake"].errors?.[
                "required"
                ]
                ) {
                <div>
                  <small class="text-danger">Select Tyre Make</small>
                </div>
                }
              </div>
              }
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label [attr.for]="'tyreModelSelect_' + i">Tyre Model<span class="text-danger"></span></label>
              <ng-select [labelForId]="'tyreModelSelect_' + i" [items]="tyreModelList[i].list" bindLabel="name" bindValue="name" [multiple]="false"
                [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Model"
                formControlName="tyreModel" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
                [readonly]="!stock.at(i).get('tyreMake')?.value || isEditMode" (change)="getFreightDetails(i)"
                (scrollToEnd)="scroll(i)" (search)="onTyreModelInputChange($event, i)" (close)="onModelClose(i)"
                (clear)="onModelClose(i)">
              </ng-select>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label [attr.for]="'quantityInput_' + i">Quantity<span class="text-danger">*</span></label>
              <input formControlName="quantity" [id]="'quantityInput_' + i" type="number" appBlockNumberSpecialchars [extraChars]="['.']"
                class="form-control no-spinner default-form-group-border" required placeholder="Quantity" [appMaxLength]="10"
                (change)="calculateTotalService()" />
              @if (
              $any(stock).controls[i].controls["quantity"].invalid &&
              ($any(stock).controls[i].controls["quantity"]?.dirty ||
              $any(stock).controls[i].controls["quantity"].touched)
              ) {
              <div>
                @if ($any(stock).controls[i].controls["quantity"].errors?.['required']) {
                  <small class="text-danger">Quantity is required</small>
                }
                @if ($any(stock).controls[i].controls["quantity"].errors?.['min']) {
                  <small class="text-danger">Quantity must be 1</small>
                }
              </div>
              }
              @if (
              $any(stock).controls[i].controls["quantity"].value &&
              $any(stock).controls[i].controls["tyresAmount"].value &&
              +$any(stock).controls[i].controls["quantity"].value > +$any(stock).controls[i].controls["tyresAmount"].value &&
              $any(stock).controls[i].controls["quantity"]?.touched &&
              $any(stock).controls[i].controls["tyresAmount"]?.touched
              ) {
              <div>
                <small class="text-warning"><span class="fw-bold">Double-check:</span> The quantity is higher than the unit price.</small>
              </div>
              }
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label [attr.for]="'tyresAmountInput_' + i">Price Per Tyre<span class="text-danger">*</span></label>
              <input formControlName="tyresAmount" [id]="'tyresAmountInput_' + i" type="number" appBlockNumberSpecialchars
                class="form-control no-spinner default-form-group-border" placeholder="Unit price" [appMaxLength]="10"
                (change)="calculateTotalService()" />
              @if (
              $any(stock).controls[i].controls["tyresAmount"].invalid &&
              ($any(stock).controls[i].controls["tyresAmount"]?.dirty ||
              $any(stock).controls[i].controls["tyresAmount"].touched)
              ) {
              <div>
                <small class="text-danger">Price is required</small>
              </div>
              }
            </div>
            <div class="col-6 col-md-3">
              <div class="amount">
                <span class="fw-semibold text-muted small d-block">Min Amount</span>
                <p class="amount-value pt-2">
                  {{ priceDetailsArray[i].minPrice || "-" }}
                </p>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="amount">
                <span class="fw-semibold text-muted small d-block">Max Amount</span>
                <p class="amount-value pt-2">
                  {{ priceDetailsArray[i].maxPrice || "-" }}
                </p>
              </div>
            </div>
            <div class="col-6 col-sm-3 col-md-2 text-center">
              <div class="amount">
                <span class="fw-semibold text-muted small d-block">Average Amount</span>
                <p class="amount-value pt-2">
                  {{ priceDetailsArray[i].avgPrice || "-" }}
                </p>
              </div>
            </div>
            <div class="col-6 col-sm-3 col-md-1 d-flex align-items-end justify-content-start">
                @if (i == stock.length - 1) {
                <button class="btn app-btn-primary me-1" type="button" (click)="addItem(i)"
                  [disabled]="isEditMode">
                  <fa-icon [icon]="faPlus" class="fa-1x"></fa-icon>
                </button>
                }
                @if (stock.length > 1) {
                <button class="btn btn-danger" type="button" (click)="removeItem(i)" [disabled]="isEditMode">
                  <fa-icon [icon]="faTrash" class="fa-1x"></fa-icon>
                </button>
                }
            </div>
          </div>
        </div>
        }
      </div>

      <h3 class="pt-3">Payment Details:</h3>
      <div class="row pt-3 g-3">
        <div class="col-12 col-sm-6 col-md-3">
          <label for="totalAmountInput">Total Price</label>
          <input formControlName="totalAmount" id="totalAmountInput" #tyresAmount type="number"
            class="form-control no-spinner default-form-group-border" placeholder="Total price" required readonly />
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="discount">Discount on Total Price</label>
          <input formControlName="discount" id="discount" type="number" appBlockNumberSpecialchars
            class="form-control no-spinner default-form-group-border" placeholder="Discount"
            (change)="calculateTotalService()" />
          @if (addProductForm.get('discount')?.errors?.['discountExceeded']) {
          <div>
            <small class="text-danger">Discount cannot be greater than or equal to the total amount.</small>
          </div>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="paymentTypeSelect">Payment Type<span class="text-danger">*</span></label>
          <ng-select labelForId="paymentTypeSelect" [items]="paymentTypes" bindLabel="label" bindValue="value" formControlName="paymentType"
            [clearable]="false" placeholder="Select Payment Type" (change)="showPayDetailsForm($event.value)"
            class="custom-ng-select">
          </ng-select>
          @if (
          addProductForm.get("paymentType")?.invalid &&
          addProductForm.get("paymentType")?.touched
          ) {
          <div>
            <small class="text-danger">Select payment type</small>
          </div>
          }
        </div>
        @if (showFullPaymentOption) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="paymentModeSelect">Payment Mode<span class="text-danger">*</span></label>
          <ng-select labelForId="paymentModeSelect" [items]="paymentModes" bindLabel="label" bindValue="value" formControlName="paymentMode"
            [clearable]="false" placeholder="Select Payment Mode" (change)="onPaymentModeChange($event.value)"
            class="custom-ng-select">
          </ng-select>
          @if (
          addProductForm.get("paymentMode")?.invalid &&
          addProductForm.get("paymentMode")?.touched
          ) {
          <div>
            <small class="text-danger">Select payment mode</small>
          </div>
          }
        </div>
        }
        @if (showSwpCharges && showFullPaymentOption) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="swpChargesInput">SWP Charges</label>
          <input formControlName="swpCharges" id="swpChargesInput" #swpCharges type="number"
            class="form-control no-spinner default-form-group-border" placeholder="Swipe charge %"
            (change)="calculateTotalService()" />
        </div>
        }
        @if (
        showFullPaymentOption &&
        addProductForm.get("paymentMode")?.value !== "Credit"
        ) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="paymentAccountSelectFull">Payment Account</label>
          <div class="d-flex align-items-center gap-2">
            <ng-select labelForId="paymentAccountSelectFull" class="flex-grow-1" [clearable]="false" formControlName="paymentAccount"
              [items]="accountState['Full'].list" bindLabel="accountName" bindValue="_id" placeholder="Select Account"
              [loading]="accountState['Full'].loading" (scrollToEnd)="onAccountScroll('Full')">
            </ng-select>
            @if (userDetails?.enrollmentType === "Company") {
            <button type="button" class="btn app-btn-outline btn-sm" (click)="
                    addNewPaymentAccount(
                      addProductForm.get('paymentMode')?.value
                    )
                  " title="Add New Payment Account">
              <fa-icon [icon]="faPlus"></fa-icon>
            </button>
            }
          </div>
        </div>
        }
      </div>
      <div class="row pt-0">
        <div class="col-md-12">
          <div id="myDiv" class="total-price"></div>
        </div>
      </div>
      @if (showSplitPaymentOption) {
      <div class="row pt-3">
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-6">
                <label for="cashAmount">Cash Amount</label>
                <input formControlName="cashAmount" id="cashAmount" type="number"
                  class="form-control no-spinner default-form-group-border" placeholder="Cash amount"
                  (input)="splitAmountSum()" />
              </div>
              <div class="col-6">
                <label for="cashAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select labelForId="cashAccountSelect" class="flex-grow-1" [clearable]="false"
                    [readonly]="!addProductForm.get('cashAmount')?.value" formControlName="cashAccount"
                    [items]="accountState['Cash'].list" bindLabel="accountName" bindValue="_id"
                    placeholder="Select Account" [loading]="accountState['Cash'].loading"
                    (scrollToEnd)="onAccountScroll('Cash')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm" (click)="addNewPaymentAccount('Cash')"
                    title="Add New Cash Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-6">
                <label for="bankTransferAmount">Bank Transfer Amount</label>
                <input formControlName="bankTransferAmount" id="bankTransferAmount" type="number"
                  class="form-control no-spinner default-form-group-border" placeholder="Bank transfer amount"
                  (input)="splitAmountSum()" />
              </div>
              <div class="col-6">
                <label for="bankTransferAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select labelForId="bankTransferAccountSelect" class="flex-grow-1" [clearable]="false" [readonly]="
                        !addProductForm.get('bankTransferAmount')?.value
                      " formControlName="bankTransferAccount" [items]="accountState['BankTransfer'].list"
                    bindLabel="accountName" bindValue="_id" placeholder="Select Account"
                    [loading]="accountState['BankTransfer'].loading" (scrollToEnd)="onAccountScroll('BankTransfer')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm"
                    (click)="addNewPaymentAccount('BankTransfer')" title="Add New Bank Transfer Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-6">
                <label for="upiAmountInput">UPI Amount</label>
                <input formControlName="upiAmount" id="upiAmountInput" #upiAmount type="number"
                  class="form-control no-spinner default-form-group-border" placeholder="UPI amount"
                  (input)="splitAmountSum()" />
              </div>
              <div class="col-6">
                <label for="upiAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select labelForId="upiAccountSelect" class="flex-grow-1" [clearable]="false"
                    [readonly]="!addProductForm.get('upiAmount')?.value" formControlName="upiAccount"
                    [items]="accountState['UPI'].list" bindLabel="accountName" bindValue="_id"
                    placeholder="Select Account" [loading]="accountState['UPI'].loading"
                    (scrollToEnd)="onAccountScroll('UPI')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm" (click)="addNewPaymentAccount('UPI')"
                    title="Add New UPI Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-6">
                <label for="bajajFinanceAmountInput">Bajaj Finance Amount</label>
                <input formControlName="bajajFinanceAmount" id="bajajFinanceAmountInput" type="number"
                  class="form-control no-spinner default-form-group-border" placeholder="Enter amount"
                  (input)="splitAmountSum()" />
              </div>
              <div class="col-6">
                <label for="bajajFinanceAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select labelForId="bajajFinanceAccountSelect" class="flex-grow-1" [clearable]="false" [readonly]="
                        !addProductForm.get('bajajFinanceAmount')?.value
                      " formControlName="bajajFinanceAccount" [items]="accountState['BajajFinance'].list"
                    bindLabel="accountName" bindValue="_id" placeholder="Select Account"
                    [loading]="accountState['BajajFinance'].loading" (scrollToEnd)="onAccountScroll('BajajFinance')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm"
                    (click)="addNewPaymentAccount('BajajFinance')" title="Add New Bajaj Finance Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-12 col-sm-6">
                <label for="cardAmountInput">Card Amount</label>
                <input formControlName="cardAmount" id="cardAmountInput" #cardAmount type="number"
                  class="form-control no-spinner default-form-group-border" placeholder="Card amount"
                  (input)="splitAmountSum()" />
              </div>
              <div class="col-12 col-sm-6">
                <label for="cardAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-1">
                  <ng-select labelForId="cardAccountSelect" class="flex-grow-1" [clearable]="false"
                    [readonly]="!addProductForm.get('cardAmount')?.value" formControlName="cardAccount"
                    [items]="accountState['Card'].list" bindLabel="accountName" bindValue="_id"
                    placeholder="Select Account" [loading]="accountState['Card'].loading"
                    (scrollToEnd)="onAccountScroll('Card')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm" (click)="addNewPaymentAccount('Card')"
                    title="Add New Card Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <label for="swpChargesCardInput">SWP Charges</label>
                <input formControlName="swpCharges" id="swpChargesCardInput" type="number"
                  [readonly]="!addProductForm.get('cardAmount')?.value"
                  class="form-control no-spinner default-form-group-border" placeholder="Swipe charge %"
                  (input)="calculateTotalService()" />
              </div>
              <div class="col-12 col-sm-6 d-flex flex-column justify-content-center">
                <span class="text-muted small d-block">SWP Amount</span>
                <span class="text-dark fs-6">₹{{ swpCharges || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      <h3 class="pt-3">Dealer Details:</h3>
      <div class="row pt-3 g-3">
        <div class="col-12 col-sm-6 col-md-3">
          <label for="dealerSelect">Dealer<span class="text-danger">*</span></label>
          <ng-select labelForId="dealerSelect" [items]="dealerList" bindLabel="name" bindValue="_id" [multiple]="false" [searchable]="true"
            placeholder="Search or Select Dealer" [searchFn]="customSearchFn" formControlName="dealerId"
            class="ng-select-bootstrap" appendTo="body" [readonly]="isEditMode" (change)="selectedDealer($event)"
            (search)="onDealerInputChange($event)" (scrollToEnd)="scrollDealer()">
          </ng-select>
          @if (
          addProductForm.controls["dealerId"].invalid &&
          (addProductForm.get("dealerId")?.dirty ||
          addProductForm.controls["dealerId"].touched)
          ) {
          <div class="errorText">
            @if (addProductForm.controls["dealerId"].errors?.["required"]) {
            <div>
              <small class="text-danger">Select Dealer</small>
            </div>
            }
          </div>
          }
        </div>
        @if (paymentMode === "Credit") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="creditLimit">Credit Limit</label>
          <input formControlName="creditLimit" id="creditLimit" type="number"
            class="form-control no-spinner default-form-group-border" placeholder="Credit limit amount" />
        </div>
        }
        @if (paymentMode === "Credit") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="delayAfterDelivery">Credit Duration</label>
          <input formControlName="delayAfterDelivery" id="delayAfterDelivery" type="number"
            class="form-control no-spinner default-form-group-border" placeholder="Credit Duration" />
        </div>
        }
      </div>
      <div class="row pt-3 g-3">
        <div class="col-12 col-md-6">
          <label for="descriptionNoteTextarea">Note</label>
          <div class="position-relative">
            <textarea formControlName="descriptionNote" id="descriptionNoteTextarea" rows="2" class="form-control default-form-group-border"
              placeholder="Note" maxlength="120"></textarea>
            <div class="text-muted small text-end mt-1">
              {{ (addProductForm.get('descriptionNote')?.value || '').length }}/120
            </div>
          </div>
        </div>
        @if (isEditMode) {
        <div class="col-12 col-md-6">
          <label for="editReasonTextarea">Reason for Edit<span class="text-danger">*</span></label>
          <textarea formControlName="editReason" id="editReasonTextarea" rows="2" class="form-control default-form-group-border"
            placeholder="Please provide a reason for editing this transaction"></textarea>
          @if (
          addProductForm.get("editReason")?.invalid &&
          addProductForm.get("editReason")?.touched
          ) {
          <div>
            <small class="text-danger">Reason for edit is required</small>
          </div>
          }
        </div>
        }
      </div>
      <div class="row pt-3 mb-5">
        <div class="col-12 text-end">
          @if (errorMessage) {
          <div class="text-center text-danger pt-2">
            {{ errorMessage }}
          </div>
          }
          <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/order-list'" [disabled]="isLoading">
            Cancel
          </button>
          <button [disabled]="addProductForm.invalid || !checkSplitCount || isLoading" type="submit"
            class="btn app-btn-primary">
            Submit
            @if (isLoading) {
            <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
            }
          </button>
        </div>
      </div>
    </form>

    <ng-template #accountFormModal let-offcanvas>
      <app-new-payment-account [showBranch]="true" [branches]="filteredActiveBranches"
        [preSelectedBranch]="preSelectedBranch" [preSelectedMode]="preSelectedMode"
        (accountSave)="onAccountSave($event)" (accountCancel)="offcanvas.dismiss()">
      </app-new-payment-account>
    </ng-template>
  </div>
</section>